import styles from "./SearchBar.module.scss";
import { useTranslation } from "react-i18next";
import icons from "helpers/icons";

const SearchBar = ({ search = "", setSearch = () => {}, onSubmit, page, setPage, placeholder, mobileVisible = false }) => {
    const { t } = useTranslation();

    return (
        <form className={`${styles.form} ${mobileVisible ? styles.mobileVisible : ""}`} onSubmit={onSubmit}>
            <input
                type="text"
                placeholder={t(placeholder)}
                aria-label={t(placeholder)}
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                }}
            />
            <button type="submit" className={styles.button} aria-label={t(placeholder)}>
                <img src={icons.search} alt="" />
            </button>
        </form>
    );
};

export default SearchBar;
